module.exports = __webpack_public_path__ + "static/media/aliceville.f1878b24.jpg";